import React from "react";
import VerifyEmailLayout from "../../../components/VerifyEmailLayout";

const VerifyEmail = React.memo(() => {
  return <VerifyEmailLayout />;
});

export default VerifyEmail;
